import { isRequiredText, strMax } from '../../utils';
export const professionalRequestServiceValidate = {
    organizationName: [
        isRequiredText('会社名を入力してください'),
        strMax(100, '会社名は100文字以内で入力してください'),
    ],
};
export default professionalRequestServiceValidate;
